<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">Products</div>
          </div>
          <v-spacer></v-spacer>
          <v-flex xs6>
            <cal-picker :label="labels.dateSearch" v-model="effDate" @input="queryInterProducts()"></cal-picker>
          </v-flex>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.productId }}</td>
          <td class="text-xs-right">{{ props.item.productDesc }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.effDate) }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.endDate) }}</td>
        </template>
      </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import toDate from 'date-fns/toDate'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Product Code', align: 'left', value: 'productId', sortable: false },
        { text: 'Product Description', align: 'right', value: 'productDesc', sortable: false },
        { text: 'Start Date', align: 'right', value: 'effDate', sortable: false },
        { text: 'End Date', align: 'right', value: 'endDate', sortable: false }
      ],
      labels: {
        dateSearch: 'Effective Intermediary Product'
      },
      effDate: undefined,
      interProducts: [],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    startDateValidation() {
      return 'required'
    },
    endDateValidation() {
      return 'start_enddate:' + this.interProductForm.effDate
    }
  },
  methods: {
    async queryInterProducts() {
      try {
        this.loading = true
        const apiURI = this.$store.state.adminInter.intermediary.menu.InterProducts
        const expand = {
          inter: this.inter,
          effDate: this.effDate
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            // Format the data here
            this.items = []
            data.map((interProduct) => {
              const convertProduct = {
                inter: interProduct.inter,
                productId: interProduct.productId,
                productDesc: interProduct.productDesc,
                effDate: interProduct.effDate,
                endDate: interProduct.endDate
              }
              this.items.push(convertProduct)
            })
          } else {
            this.items = []
          }
        }
        this.loading = false
      } catch (err) {
        throw err
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(toDate(xDate))
      }
    }
  },
  mounted() {
    this.effDate = new Date()
    Promise.all([this.queryInterProducts()])
  },
  props: ['inter'],
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
